import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApprovedNotFunded = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9997 14.5563L19.4442 19.0007M19.4442 14.5563L14.9997 19.0007M19.8886 9.22295H2.11084M19.8886 11.0007V7.62295C19.8886 6.6273 19.8886 6.12948 19.6949 5.74919C19.5244 5.41468 19.2524 5.14271 18.9179 4.97227C18.5376 4.7785 18.0398 4.7785 17.0442 4.7785H4.95529C3.95964 4.7785 3.46181 4.7785 3.08152 4.97227C2.74701 5.14271 2.47505 5.41468 2.30461 5.74919C2.11084 6.12947 2.11084 6.6273 2.11084 7.62295V14.3785C2.11084 15.3742 2.11084 15.872 2.30461 16.2523C2.47505 16.5868 2.74701 16.8587 3.08152 17.0292C3.46181 17.2229 3.95964 17.2229 4.95528 17.2229H10.9997",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgApprovedNotFunded;
